// extracted by mini-css-extract-plugin
export default {"container":"working_container__NxXXK","getInTouch":"working_getInTouch__6gbzs","projects":"working_projects__tq6rQ","signature":"working_signature__BNzwu"};